module.exports = __webpack_public_path__ + "img/20210730_122542.8685f14c.jpg";